// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"_baa44976","pageLinks":"_f3b3cebe"};